// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionB_TheComp__pc_Z6"};